module.exports = __webpack_public_path__ + "static/media/ansiktsmask.5e4b8036.svg";